import { Heading, Span } from "@icg360/design-system";

import logo from "../../assets/logo-horz-full-color-opt.svg";
import styles from "./Footer.module.css";

export const Footer = ({ carrierLogoUrl }: { carrierLogoUrl: string }) => {
  return (
    <div className={styles.footer}>
      <div className={styles.footerImages}>
        <div className={styles.sageSureFooterLogo}>
          <img src={logo} alt="SageSure Logo" width={224} height={50} />
        </div>
        <img src={carrierLogoUrl} alt="Carrier Logo" height={90} width={90} />
      </div>
      <div className={styles.footerText}>
        <Heading size="lg">Experienced Insurance Partners</Heading>
        <div className={styles.footerImages}>
          <div className={styles.sageSureFooterLogo}>
            <img src={logo} alt="SageSure Logo" width={224} height={50} />
          </div>
          <img src={carrierLogoUrl} alt="Carrier Logo" height={90} width={90} />
        </div>
        <Span>
          We deliver strong, stable products and coverages that will be there
          when you need them most. SageSure only partners with highly rated
          carriers with strong financial ratings from AM Best or Demotech.
        </Span>
        <Span size="sm" color="quiet">
          This document represents an insurance quote, not an insurance policy,
          and is based on information provided by you or your insurance
          representative. It does not guarantee coverage and is subject to
          change.
        </Span>
      </div>
    </div>
  );
};
